var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overdue icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 8.00004,
    cy: 11.2,
    r: 0.96,
    fill: "#680000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.04004,
    y: 3.83997,
    width: 1.92,
    height: 5.76,
    rx: 0.96,
    fill: "#680000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.087645a71d181c70591bf5326f5647d7.svg";
export { ForwardRef as ReactComponent };